import * as React from 'react';

import type { WosIconProps } from 'types/common_types';

function arrangementsSave(props: WosIconProps) {
  const { className } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      className={className}
      viewBox="0 0 721.1 663.49"
    >
      <path d="M147.95,3.11H13.66C6.92,3.11,1.45,8.23,1.45,14.53V197.33c0,6.31,5.47,11.42,12.21,11.42H147.95c6.74,0,12.21-5.12,12.21-11.42V14.53c0-6.31-5.47-11.42-12.21-11.42Z" />
      <path d="M147.95,231.6H13.66c-6.74,0-12.21,5.12-12.21,11.42v91.4c0,6.31,5.47,11.42,12.21,11.42H147.95c6.74,0,12.21-5.12,12.21-11.42v-91.4c0-6.31-5.47-11.42-12.21-11.42Z" />
      <path d="M331.08,3.11H196.79c-6.74,0-12.21,5.12-12.21,11.42V105.93c0,6.31,5.47,11.42,12.21,11.42h134.29c6.74,0,12.21-5.12,12.21-11.42V14.53c0-6.31-5.47-11.42-12.21-11.42Z" />
      <path d="M331.08,140.2H196.79c-6.74,0-12.21,5.12-12.21,11.42v182.8c0,6.31,5.47,11.42,12.21,11.42h134.29c6.74,0,12.21-5.12,12.21-11.42V151.63c0-6.31-5.47-11.42-12.21-11.42Z" />
      <path d="M705.42,192.01c-18.98-19.01-49.64-19.01-68.62,0l-355.69,354.17L122.52,386.33c-18.98-18.98-49.73-18.98-68.71,0-18.97,18.98-18.97,49.64,0,68.62l194.36,194.31c18.98,18.98,49.64,18.98,68.62,0l388.63-388.63c18.98-18.98,18.98-49.64,0-68.62Z" />
    </svg>
  );
}

export default arrangementsSave;
